import PropTypes from 'prop-types';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';

const overnightIndicatorStyles = css`
  align-self: center;
  background-color: ${etiColors.grayScale[9]};
  border-radius: 2px;
  color: ${etiColors.white};
  font-size: 0.625rem;
  font-weight: 700;
  margin-left: 8px;
  padding: 0 4px;
  position: absolute;
  top: 7px;
  vertical-align: middle;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 8px;
  }

  @media ${mediaQueries.medium.up} {
    padding: 0 4px 1px;
    top: 10px;
  }

  @media ${mediaQueries.large.up} {
    font-size: 0.75rem;
    top: 11px;
  }

  @media ${mediaQueries.xlarge.up} {
    padding: 1px 4px;
    top: 8px;
  }
`;

const plusSign = '+';

const TripDetailsOvernightIndicator = ({ className, durationInDays }) => (
  <span
    className={cx(overnightIndicatorStyles, className)}
    data-testid="result-tripDetails-TripDetailsOvernightIndicator"
  >
    {plusSign}
    {durationInDays}
  </span>
);

TripDetailsOvernightIndicator.propTypes = {
  className: PropTypes.string,
  durationInDays: PropTypes.number,
};

export default TripDetailsOvernightIndicator;
